import {api} from "../../../../../api/API";
import {ContainerPage} from "../../../../../misc/pdf/parts/ContainerPage";
import {GenericContainerPage} from "../../../../../misc/pdf/parts/GenericContainerPage";

export function PdfTableServerRendered(props: {
    generic?: boolean;
    orientation?: "portrait" | "landscape";
    value: Parameters<typeof api.pdfTable.encodeContent>[0]
}) {
    if(props.generic) {
        return (
            <GenericContainerPage orientation={props.orientation||"landscape"}>
                <div className={api.pdfTable.tableClassName} style={api.pdfTable.defaultStyle}>
                    {api.pdfTable.encodeContent(props.value)}
                </div>
            </GenericContainerPage>
        )
    }

    return (
        <ContainerPage>
            <div className={api.pdfTable.tableClassName} style={api.pdfTable.defaultStyle}>
                {api.pdfTable.encodeContent(props.value)}
            </div>
        </ContainerPage>
    )
}